module.exports = __webpack_public_path__ + "static/media/image.34b316ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/image.svg
// module id = 635
// module chunks = 1